import React from 'react';
import { SvgIcon } from './svg-icon';

export const Download = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </SvgIcon>
);
